import { render, staticRenderFns } from "./Bot.vue?vue&type=template&id=02ac6847&"
import script from "./Bot.vue?vue&type=script&lang=js&"
export * from "./Bot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ac6847')) {
      api.createRecord('02ac6847', component.options)
    } else {
      api.reload('02ac6847', component.options)
    }
    module.hot.accept("./Bot.vue?vue&type=template&id=02ac6847&", function () {
      api.rerender('02ac6847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Bot.vue"
export default component.exports